import { createSelector } from 'reselect';

import {
  getOrgSettings,
  getItemsFromState,
  getDataFromStateAndProps,
} from './common';

import { getUsers } from './users';


export const getRequestLogs = createSelector(
  [
    getDataFromStateAndProps('logs'),
    getOrgSettings('requestStatuses'),
    getUsers,
    getItemsFromState('attachments'),
  ],
  (logs, requestStatuses, users, items) =>
    Object.keys(logs).map(key => ({
      ...logs[key],
      payload: {
        ...logs[key].payload,
        newAttachments: logs[key].payload.newAttachments &&
            logs[key].payload.newAttachments.map((attachment, idx) =>
              ({
                ...{
                  url: logs[key].payload.newAttachments.map(file =>
                    items[file._id] && items[file._id].url)[idx],
                },
                ...attachment,
              })),
        initialStatus: requestStatuses[logs[key].payload.initialStatus],
        changedFrom: requestStatuses[logs[key].payload.changedFrom],
        changedTo: requestStatuses[logs[key].payload.changedTo],
      },
      createdBy: users[logs[key].createdBy] || {},
    })),
);



// WEBPACK FOOTER //
// ./src/redux/selectors/requestLogs.js